import { render, staticRenderFns } from "./APP_informationList.vue?vue&type=template&id=435bae1c&scoped=true&"
import script from "./APP_informationList.vue?vue&type=script&lang=js&"
export * from "./APP_informationList.vue?vue&type=script&lang=js&"
import style0 from "./APP_informationList.vue?vue&type=style&index=0&id=435bae1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435bae1c",
  null
  
)

export default component.exports